import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderDepartments() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 8,
                        spaceBetween: 0,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/general-surgery"><img src="assets/img/General Surgery_7.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>जनरल सर्जरी</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/general-medicine"><img src="assets/img/General Medicine_3.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>सामान्य दवा</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/paediatrics"><img src="assets/img/Paediatrics_2.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>बाल चिकित्सा</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/orthopedic"><img src="assets/img/Orthopedic_8.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>हड्डी रोग संबंधी</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/gynaecology"><img src="assets/img/Gynaecology_5.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>प्रसूति एवं स्त्री रोग</b></p>
                        </div>
                    </li>
                </SwiperSlide>
               
                
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/dental"><img src="assets/img/Dental_1.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>दांत से संबंधित</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/ent"><img src="assets/img/कान, नाक और गले (ENT).webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>कान, नाक और गले</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/anaesthesiology"><img src="assets/img/ANAESTHESIOLOGY.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>अनेस्थिसियोलॉजी</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/dermatology"><img src="assets/img/DERMATOLOGY.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>त्वचा विशेषज्ञ</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/urology"><img src="assets/img/UROLOGY.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>यूरोलॉजी</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/pulmonology"><img src="assets/img/PULMONOLOGY.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>फेफड़ों/छाती</b></p>
                        </div>
                    </li>
                </SwiperSlide>
                <SwiperSlide>
                    <li data-tab="#prod-cancer" className="tab-btn active-btn" >
                        <div className="">
                            <Link to="/physiotherapy"><img src="assets/img/Physiotherapy.webp" style={{ width: "100px", height: "100px", borderRadius: "50px" }} alt /></Link>
                            <p style={{ textAlign: "", color: "black" }}><b>फिजियोथेरेपी</b></p>
                        </div>
                    </li>
                </SwiperSlide>

            </Swiper>
        </>
    );
}
